/**
 * 表单字段配置项
 */
// 展品路由正则
const exhibitsDetailPath = /\/find-exhibit\/detail\/([0-9A-Za-z]{10,}$)/
// 展商路由正则
const exhibitorDetailPath = /\/find-exhibitor\/detail\/([0-9A-Za-z]{10,}$)/
const reportPath =  /\/report\/(actorIndex|personReport)$/
const mapPath = /\/map(\/(.*))?/

export default {
  /**
   * 注册流程页面需要限制 暂时没有做
   * 展商身份 非管理员的页面 没有限制，暂时没有做
   */
  /**
   * 白名单
   * 包括 需要身份(ACTOR、VISITOR) 路由
   *      不需要身份(为空) 路由
   */
  whiteList: [
    '/', '/login', '/login/actor', '/login/person', '/aboutus','/qa',
    '/l-register/account-email-info/0',
    '/register/email/1',
    '/register/email/2',
    '/register/password/vis','/register/password/actor',
    '/register/mobile/0',
    '/find/actor', '/find/product', '/search-list',
    '/l-register/account-mobile-info/0',
    '/register/account-info/1', '/questionnaire', '/agreement', 
    exhibitsDetailPath, exhibitorDetailPath, mapPath
  ],
  // 注册设置密码，强制设置身份 路由
  setIdentityList: ['/register/password/vis','/register/password/actor'],
  // 工作台路由
  workRouterList: [
    '/exh-Information',
    '/my-exhibit-list',
    '/add-exhibit',
    '/my-employee-list',
    '/add-employee',
    '/company-management',
    '/company-info',
    '/opportunity-manage/list',
    '/opportunity-manage/publish',
    '/chat', '/invite', '/mail',
    '/footprint/exhibitor',
    '/footprint/product',
    '/footprint/person',
    '/collection/exhibitor',
    '/collection/product',
    '/collection/audience',
    '/liveManage',
    '/potential-order',
    '/potential-order/me',
    '/personal/questionnaire/change',
    '/profile',
    '/companyfile',
    '/statistical', reportPath]
}